import { sec } from './units.ts';

/**
 * Prior Lucan (cleric, shadow): he prayed in the chapel to the end, and nobody came (docs/ANTIHEROES.md, "Los siete
 * que faltan"). He fights from afar, mends the nightmares around him, keeps the souls of those who fall near him and
 * raises them as skeletons. Hurts like every Unsleeping: at least `maxHpBp` of the hero's own health.
 */
export const LUCAN = {
  /** His blow: a bolt of shadow at the nearest hero within `reach` (he stands to shoot), at least `blowMaxHpBp` of its health. */
  reach: 4500,
  blowMaxHpBp: 700,
  /** Unanswered prayer (passive): every `every`, each other nightmare within `radius` mends `healBp` of its life; ×`phaseBp` from 66 %. */
  prayer: { radius: 3500, every: sec(1), healBp: 250, phaseBp: 20000 },
  /** A nightmare falling within `radius` of him leaves him a soul, up to `max`. */
  souls: { radius: 4500, max: 12 },
  /** Vigil whip: a chain from him to a hero in `range`, then to the nearest unstruck within `jump`, `heroes` in all; each cursed (heals at `healBp`). */
  whip: { every: sec(6), range: 4500, jump: 3000, heroes: 3, damage: 40, maxHpBp: 900, curse: sec(6), healBp: 5000 },
  /** Raise the fallen: spends his souls (at least `min`) for as many skeletons in a ring `ring` around him. */
  raise: { every: sec(14), min: 1, ring: 900 },
  /**
   * The Empty Chapel (ultimate): a circle of `radius` around him. Landing, every other nightmare in it heals whole and
   * takes a ward of `wardBp` of its life; heroes in it take `damage` (at least `maxHpBp` of their health) and flee in fear `fear`.
   * From 33 % it also raises all his souls, without spending them.
   */
  chapel: { radius: 3200, damage: 200, maxHpBp: 4000, fear: sec(2), wardBp: 3000 },
};
